const iconMap: Record<number, string> = {
  1: require("../assets/icons/wt_arrival.png"),
  2: require("../assets/icons/wt_packing.png"),
  3: require("../assets/icons/wt_planCreate.png"),
  4: require("../assets/icons/wt_shipping.png"),
  5: require("../assets/icons/cp_shipping.png"),
  6: require("../assets/icons/wt_check.png"),
};

export default iconMap;
